import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('toggle-switch', {
  root: {
    variants: {
      size: ['small', 'medium', 'large'],
      skin: ['standard', 'success', 'error', 'urgent'],
    },
    states: ['checked', 'disabled', 'focus', 'focusVisible'],
  },
  track: {},
  knob: {},
  knobIcon: {},
  input: {},
});
